import { render, staticRenderFns } from "./LikertModification.vue?vue&type=template&id=68f8be0e&scoped=true&"
import script from "./LikertModification.vue?vue&type=script&lang=js&"
export * from "./LikertModification.vue?vue&type=script&lang=js&"
import style0 from "./LikertModification.vue?vue&type=style&index=0&id=68f8be0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f8be0e",
  null
  
)

export default component.exports